const base = {
    get() {
        return {
            url : "http://localhost:8080/zhihuijiaoyu/",
            name: "zhihuijiaoyu",
            // 退出到首页链接
            indexUrl: 'http://localhost:8080/zhihuijiaoyu/front/index.html'
        };
    },
    getProjectName(){
        return {
            projectName: "高校智慧教育平台"
        } 
    }
}
export default base
